import React from 'react';

class AppHeightObserver extends React.Component {
    constructor(props) {
        super(props);
        this.resizeObserver = null;
        this.lastHeight = null;
    }

    componentDidMount() {
        if (typeof ResizeObserver === 'undefined') {
            // Fallback for browsers without ResizeObserver support
            console.warn('ResizeObserver is not supported in this browser');
            return;
        }

        this.resizeObserver = new ResizeObserver((entries) => {
            // Use requestAnimationFrame to avoid "ResizeObserver loop limit exceeded" errors
            window.requestAnimationFrame(() => {
                if (!entries || !entries.length) return;

                const entry = entries[0];
                // borderBoxSize is more accurate but not universally supported; fallback to contentRect
                const newHeight = entry.contentRect
                    ? entry.contentRect.height
                    : entry.target.offsetHeight;

                this.emitHeightChange(newHeight);
            });
        });

        this.resizeObserver.observe(document.documentElement);
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }

    emitHeightChange(newHeight) {
        const roundedHeight = Math.round(newHeight);

        // Only emit if the height actually changed
        if (roundedHeight === this.lastHeight) return;

        this.lastHeight = roundedHeight;

        // Post message to parent window (e.g. if embedded in an iframe)
        if (window.parent && window.parent !== window) {
            window.parent.postMessage(
                {
                    resize: true,
                    height: roundedHeight,
                },
                '*'
            );
        }
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                {this.props.children}
            </div>
        );
    }
}

export default AppHeightObserver;